import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { routes } from '../../constants';
import { changeHead } from '../../redux/head/headActions';
import { fetchFAQ, fetchTestimonies } from '../../redux/content/contentActions';
import { ABreadCrumb } from '../../components/atoms';
import { MHeroImageSlider } from '../../components/molecules';
import {
	OHouseHoldInfographic,
	OHouseHoldIntro,
	OHouseHoldStory,
	OTestimonial,
	OFaq,
	OContactBanner,
	OCategoriePreview,
} from '../../components/organisme';
import {
	huishoudelijkHero1,
	huishoudelijkHero2,
	householdStory1Image,
	householdStory2Image,
} from '../../assets/images/images';

const mapStateToProps = state => ({
	faq: state.content.faq,
	testimonies: state.content.testimonies,
});

class HouseHoldPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			faq: undefined,
			testimonies: undefined,
		};

		this.bindHandles();
	}

	componentDidMount() {
		this.props.fetchFAQ();
		this.props.fetchTestimonies();
		this.props.changeHead({
			id: pageConfig.household.id,
			title: this.props.intl.formatMessage({ id: pageConfig.household.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.household.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleAskDemo = this.handleAskDemo.bind(this);
	}

	handleAskDemo() {
		this.props.history.push(routes.HOUSEHOLD.CONTACT);
	}

	render() {
		let faq;
		let testimonial;

		if (this.state.faq && this.state.faq.length) {
			faq = (
				<div className="o-section-faq--household">
					<OFaq
						title={this.state.faq[0].name}
						items={this.state.faq[0].faqs}
						className="section-xx layout-body household-home-story"
					/>
				</div>);
		}

		if (this.state.testimonies && this.state.testimonies.length) {
			testimonial = <OTestimonial items={this.state.testimonies} />;
		}

		return (
			<section className="household-wrapper">
				<MHeroImageSlider
					items={[huishoudelijkHero1, huishoudelijkHero2]}
					className="a-hero-home"
				>
					<a href={routes.externalStore} target="_blank" className="m-hero--cta-store">
						<ABreadCrumb
							currentPage="HOUSEHOLD.CTA_STORE.TITLE"
							className="a-breadcrumb--reverse a-breadcrumb--override-large"
						/>
					</a>
				</MHeroImageSlider>
				<OHouseHoldInfographic className="section-xx layout-body household-home-story" />
				{testimonial}
				<OHouseHoldStory
					img={householdStory1Image}
					title="HOUSE_HOLD.STORY_PRIMARY_TITLE"
					description="HOUSE_HOLD.STORY_PRIMARY_DESCRIPTION"
					className="section-xx layout-body household-home-story"
				/>
				<OHouseHoldStory
					img={householdStory2Image}
					direction="reverse"
					title="HOUSE_HOLD.STORY_SECONDARY_TITLE"
					description="HOUSE_HOLD.STORY_SECONDARY_DESCRIPTION"
					className="section-xx layout-body household-home-story full-image"
				/>
				<OHouseHoldIntro
					onClick={this.handleAskDemo}
				/>
				{faq}
				<div className="section-xx t-gap--top-xl t-gap--bottom-xl">
					<OCategoriePreview items={pageConfig.household.productPreviewList} />
				</div>
				<OContactBanner type="household" href={`${routes.HOUSEHOLD.CONTACT}`} />
			</section >
		);
	}
}

HouseHoldPage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	fetchFAQ: PropTypes.func.isRequired,
	fetchTestimonies: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHead,
	fetchFAQ,
	fetchTestimonies,
})(injectIntl(HouseHoldPage)));



// WEBPACK FOOTER //
// ./src/pages/household/household.page.js